import { useInfiniteQuery, useQuery } from '@tanstack/react-query';
import { useAuth } from '../../../../contexts/authContext';
import { contactDossierClient } from './contactDossierClient';
const client = contactDossierClient;
// Dossiers are filtered per viewer on the server and the app QueryClient
// outlives a sign-out, so every key carries the viewer (tenant + user).
function useViewerKey() {
    const { user } = useAuth();
    return `${user?.tenant_id ?? ''}:${user?.id ?? ''}`;
}
export const contactDossierKeys = {
    all: [
        'registry',
        'contact-dossier'
    ],
    dossier: (viewer, id)=>[
            ...contactDossierKeys.all,
            'dossier',
            viewer,
            id
        ],
    touchpoints: (viewer, id)=>[
            ...contactDossierKeys.all,
            'touchpoints',
            viewer,
            id
        ],
    documents: (viewer, id)=>[
            ...contactDossierKeys.all,
            'documents',
            viewer,
            id
        ]
};
export function useContactDossier(tenantId, contactId) {
    const viewer = useViewerKey();
    return useQuery({
        queryKey: contactDossierKeys.dossier(viewer, contactId),
        queryFn: ()=>client.getContactDossier(tenantId, contactId),
        enabled: !!tenantId && !!contactId,
        retry: false
    });
}
export function useContactTouchpoints(tenantId, contactId, enabled) {
    const viewer = useViewerKey();
    return useInfiniteQuery({
        queryKey: contactDossierKeys.touchpoints(viewer, contactId),
        queryFn: ({ pageParam })=>client.listContactTouchpointsUnified(tenantId, contactId, pageParam),
        initialPageParam: '',
        getNextPageParam: (last)=>last.nextAfterId || undefined,
        enabled: enabled && !!tenantId && !!contactId,
        retry: false
    });
}
export function useContactDocuments(tenantId, contactId, enabled) {
    const viewer = useViewerKey();
    return useQuery({
        queryKey: contactDossierKeys.documents(viewer, contactId),
        queryFn: ()=>client.listEntityDocuments(tenantId, contactId),
        enabled: enabled && !!tenantId && !!contactId,
        retry: false
    });
}
